import { WidgetConfig, WidgetEventHandler, WidgetEventType } from './../../types';
import { apiGet, APIURL, cancelSelectEvent, getCSSStyles, getHeaderPinButtonHTML, getHeaderPinStateClass, getNoDataHTML, getWidgetDataURI, isHeaderPinned, normalizeWidgetTheme, setupHeaderPin, toggleWidgetTheme } from './../../helpers';

export class TraderverseBiggestGainers {
  private container?: HTMLElement;
  private shadowRoot?: ShadowRoot;
  private gainerData: any = null;
  private eventListeners: { [event: string]: Function[] } = {};
  private eventHandlers: Map<WidgetEventType, WidgetEventHandler[]> = new Map();
  private config: WidgetConfig;
  private updateInterval: any = null;
  private widgetResizeObserver: any = null;
  private isLoading: boolean = false;
private get hasData(): boolean {
  return Array.isArray(this.gainerData) && this.gainerData.length > 0;
}  constructor(config: WidgetConfig) {
    this.config = config;
    this.config.theme = normalizeWidgetTheme(this.config.theme);
    this.init();
  }

  public init(): void {
    this.container = this.resolveContainer(this.config.container);
    if ((this.container as any).shadowRoot) {
      this.shadowRoot = (this.container as any).shadowRoot;
    } else {
      this.shadowRoot = this.container.attachShadow({ mode: 'closed' });
    }
    this.attachStyles();
    this.isLoading = true;
    this.renderBiggestGainersWidget();
    this.setLoadingClass(true);
    this.fetchBiggestGainers('5d');
    cancelSelectEvent(this.shadowRoot);
  }

  public on(event: string, listener: Function): void {
    if (!this.eventListeners[event]) {
      this.eventListeners[event] = [];
    }
    this.eventListeners[event].push(listener);
  }

  public off(event: string, listener: Function): void {
    if (!this.eventListeners[event]) return;
    this.eventListeners[event] = this.eventListeners[event].filter(l => l !== listener);
  }

  private emit(event: string, ...args: any[]): void {
    if (this.eventListeners[event]) {
      this.eventListeners[event].forEach(listener => listener(...args));
    }
  }

 private async fetchBiggestGainers(interval: string = '5d'): Promise<void> {
  this.isLoading = true;
  this.setLoadingClass(true);
  try {
    const url = `${APIURL}/v3/discover/movers?type=Gainer&interval=${encodeURIComponent(interval)}`;
    const response = await apiGet({
      url,
      method: 'GET',
    });

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    const data = await response.json();
    this.gainerData = data?.data?.Gainer || [];
    console.log('Gainer Data:', this.gainerData);
    this.isLoading = false;
    this.setLoadingClass(false);
    this.renderGainerRows();
  } catch (err) {
    this.isLoading = false;
    this.setLoadingClass(false);
    console.error('Failed to fetch biggest gainers:', err);
  }
}
  private setLoadingClass(isLoading: boolean): void {
    if (!this.shadowRoot) return;
    const widgetBox = this.shadowRoot.querySelector('.widgetBox');
    if (widgetBox) {
      if (isLoading) {
        widgetBox.classList.add('loading');
      } else {
        widgetBox.classList.remove('loading');
      }
    }
  }

  

  private async attachStyles(): Promise<void> {
    try {
      const styleEl = await getCSSStyles();
      this.shadowRoot!.appendChild(styleEl);
    } catch (err) {
      console.error('Failed to load CSS file:', err);
    }
  }

  private resolveContainer(container: string | HTMLElement): HTMLElement {
    if (typeof container === 'string') {
      const el = document.getElementById(container) || document.querySelector(container);
      if (!el) throw new Error(`Container not found: ${container}`);
      return el as HTMLElement;
    }
    return container;
  }

private renderBiggestGainersWidget(): void {
  let themeClass = 'defaultDarkMode';
let dataTheme = 'default-dark';

if (this.config.theme === 'white') {
  themeClass = 'whiteMode';
  dataTheme = 'white';
} else if (this.config.theme === 'black') {
  themeClass = 'blackMode';
  dataTheme = 'black';
} else if (this.config.theme === 'default-lite') {
  themeClass = 'defaultLightMode';
  dataTheme = 'default-lite';
}
  this.shadowRoot!.innerHTML = `
    <div style="width: ${typeof this.config.width == "number" ? this.config.width+ 'px' : this.config.width  };height: ${typeof this.config.height == "number" ? this.config.height+ 'px' : this.config.height};" class="widgetBox" data-theme="white">
      <div class="headTop">
        <h4 class="title market">${this.getTitleIconSvg()} Biggest Gainers
        </h4>
        <div class="actionCol">${getHeaderPinButtonHTML(this.config)}<i class="pi pi-ellipsis-v"></i></div>
      </div>

      <div class="inBody">
        <div class="optionsRow">
          <div class="item"></div>
          <span></span>
          <div class="item">
            <select class="timeperiod-select">
              <option value="1d">1 Day</option>
              <option value="5d" selected="">5 Day</option>
              <option value="1m" >This Month</option>
              <option value="1y">This Year</option>
            </select>
          </div>
        </div>

        <div class="chartDv" id="analystPriceTargetContainer">
          <div class="eventsMain customGrid" style="--grid-template-columns: 1.2fr 1fr 1fr 1fr; min-width:400px;">
            <div class="item header">
              <p>Ticker</p>
              <p>Price</p>
              <p>Market Cap</p>
              <p>Vol</p>
            </div>
            <div class="bodyContainer"></div>
          </div>
        </div>
      </div>
    </div>
  `;

  const filtersToggleBtn = this.shadowRoot!.querySelector('.filters-toggle');
  const filtersBox = this.shadowRoot!.querySelector('.filtersBox');
  if (filtersToggleBtn && filtersBox) {
    filtersToggleBtn.addEventListener('click', () => {
      filtersBox.classList.toggle('hidden');
    });
  }

  const timeperiodSelect = this.shadowRoot!.querySelector('.timeperiod-select') as HTMLSelectElement;
  if (timeperiodSelect) {
    timeperiodSelect.addEventListener('change', (e) => {
      const interval = (e.target as HTMLSelectElement).value;
      this.fetchBiggestGainers(interval);
    });
  }

  this.renderGainerRows();
}

  private renderGainerRows(): void {
    const container = this.shadowRoot!.querySelector('.bodyContainer');
    if (!container) return;
    const isEmptyArray = Array.isArray(this.gainerData) && this.gainerData.length === 0;
    const isEmptyObject = this.gainerData && typeof this.gainerData === 'object' && !Array.isArray(this.gainerData) && Object.keys(this.gainerData).length === 0;
    if (isEmptyArray || isEmptyObject) {
      container.innerHTML = getNoDataHTML();
      return;
    }
    const chartDv = this.shadowRoot!.querySelector('.chartDv');
if (this.hasData) {
  chartDv?.setAttribute('data-testing-id', 'biggest-gainers-chart');
} else {
  chartDv?.removeAttribute('data-testing-id');
}
    if (!Array.isArray(this.gainerData)) return;
    container.innerHTML = '';
    this.gainerData.forEach((gainer: any,index: number) => {
      const marketCapValue =
  typeof gainer['market_cap'] === 'number'
    ? this.formatMarketCap(gainer['market_cap'])
    : '-';
      const row = document.createElement('div');
      const logoUrl = `https://storage.googleapis.com/analytics-images-traderverse/stocks_v1/${gainer.symbol}.svg`;
      row.className = 'item body';
if (this.hasData) {
  row.setAttribute('data-testing-id', `biggest-gainer-item-${index}`);
}      row.setAttribute('data-index', index.toString());
      row.innerHTML = `
        <p class="initials"><img src="${
            logoUrl || ""
          }" alt="${logoUrl}" style="width:24px;height:24px;border-radius:4px;"/> <span>${gainer.symbol}</span></p>
        <p>${gainer.price?.toFixed(2) || '-'}</p>
        <p><span class="rangeFigure green">${marketCapValue}</span></p>
        <p class="stat">${(gainer.relative_volume || '-').toLocaleString()}</p>
      `;
      container.appendChild(row);
    });
  }

  public async getWidgetImage(): Promise<string> {
    const widget = this.shadowRoot!.querySelector('.widgetBox') as HTMLElement;
    return await getWidgetDataURI(widget);
  }

private updateDisplay(): void {
  const chartDv = this.shadowRoot?.querySelector('.chartDv') as HTMLElement;

  const hasData =
    Array.isArray(this.gainerData) &&
    this.gainerData.length > 0;

  if (hasData) {
    chartDv?.setAttribute('data-testing-id', 'biggest-gainers-chart');
  } else {
    chartDv?.removeAttribute('data-testing-id');
  }

if (!this.hasData) {
  setTimeout(() => this.updateDisplay(), 100);
  return;
} {
      setTimeout(() => this.updateDisplay(), 100);
      return;
    }
    this.renderGainerRows();
  }

    private formatMarketCap(value: number): string {
  if (value >= 1e12) {
    return (value / 1e12).toFixed(2) + 'T';
  }
  if (value >= 1e9) {
    return (value / 1e9).toFixed(2) + 'B';
  }
  if (value >= 1e6) {
    return (value / 1e6).toFixed(2) + 'M';
  }
  if (value >= 1e3) {
    return (value / 1e3).toFixed(2) + 'K';
  }
  return value.toString();
}


  public setTheme(theme: 'white' | 'black' | 'default-dark' | 'default-lite' | 'default-lite'): void {
  if (!this.shadowRoot) return;

  this.config.theme = toggleWidgetTheme(
    this.shadowRoot,
    theme
  ) as 'white' | 'black' | 'default-dark' | 'default-lite' | 'default-lite';

  this.updateDisplay();
}

  public destroy(): void {
    if (this.updateInterval) { clearInterval(this.updateInterval); this.updateInterval = null; }
    if (this.widgetResizeObserver) { this.widgetResizeObserver.disconnect(); this.widgetResizeObserver = null; }
    this.eventHandlers.clear(); this.shadowRoot!.innerHTML = '';
  }


  private getTitleIconSvg(): string {
    return `<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.75 28.4375H11.25C4.4625 28.4375 1.5625 25.5375 1.5625 18.75V11.25C1.5625 4.4625 4.4625 1.5625 11.25 1.5625H18.75C25.5375 1.5625 28.4375 4.4625 28.4375 11.25V18.75C28.4375 25.5375 25.5375 28.4375 18.75 28.4375ZM11.25 3.4375C5.4875 3.4375 3.4375 5.4875 3.4375 11.25V18.75C3.4375 24.5125 5.4875 26.5625 11.25 26.5625H18.75C24.5125 26.5625 26.5625 24.5125 26.5625 18.75V11.25C26.5625 5.4875 24.5125 3.4375 18.75 3.4375H11.25Z" fill="currentColor"/>
            <path d="M9.16252 19.05C8.96252 19.05 8.76252 18.9875 8.58752 18.85C8.17502 18.5375 8.10002 17.95 8.41252 17.5375L11.3875 13.675C11.75 13.2125 12.2625 12.9125 12.85 12.8375C13.425 12.7625 14.0125 12.925 14.475 13.2875L16.7625 15.0875C16.85 15.1625 16.9375 15.1625 17 15.15C17.05 15.15 17.1375 15.125 17.2125 15.025L20.1 11.3C20.4125 10.8875 21.0125 10.8125 21.4125 11.1375C21.825 11.45 21.9 12.0375 21.575 12.45L18.6875 16.175C18.325 16.6375 17.8125 16.9375 17.225 17C16.6375 17.075 16.0625 16.9125 15.6 16.55L13.3125 14.75C13.225 14.675 13.125 14.675 13.075 14.6875C13.025 14.6875 12.9375 14.7125 12.8625 14.8125L9.88752 18.675C9.72502 18.925 9.45002 19.05 9.16252 19.05Z" fill="currentColor"/>
          </svg>`;
  }

}

declare global {
  interface Window { TraderverseBiggestGainers?: typeof TraderverseBiggestGainers; }
}

if (typeof window !== 'undefined') {
  window.TraderverseBiggestGainers = TraderverseBiggestGainers;
}
